/**
 * Builds the two letter avatar fallback for a user, tolerating partially
 * filled in names (for example while the profile form is being edited).
 */
export function getInitials(firstName?: string, lastName?: string): string {
  const initials = [firstName?.trim()[0], lastName?.trim()[0]].filter(Boolean).join("");

  return initials.toUpperCase() || "?";
}

/**
 * Joins a user's first and last name, skipping either part when missing.
 */
export function getFullName(firstName?: string, lastName?: string): string {
  return [firstName?.trim(), lastName?.trim()].filter(Boolean).join(" ");
}
